import {
  AddIcon,
  ButtonLink,
  Popup,
  PopupContent,
  PopupFooter,
  PopupHeader,
  PopupProps,
  Typography,
} from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { BookingTemplatesList } from './BookingTemplatesList'

interface BookingTemplatesPopupProps extends Pick<PopupProps, 'open' | 'anchorEl'> {
  onClose: () => void
}

export const BookingTemplatesPopup: FC<BookingTemplatesPopupProps> = ({ open, anchorEl, onClose, ...props }) => {
  const { translate } = useI18n()

  return (
    <Popup
      open={open}
      anchorEl={anchorEl}
      onClickAway={onClose}
      width={600}
      height={360}
      placement="right-start"
      {...props}
    >
      <PopupHeader paddingRight={0}>
        <Typography color="textSecondary">{translate('sidebar-new_quote-booking_templates')}</Typography>
        <ButtonLink
          to="/booking-templates/create"
          startIcon={<AddIcon />}
          onClick={onClose}
          data-userlane-id="button-booking-templates-popup-create"
        >
          {translate('recent_booking_templates-create_template')}
        </ButtonLink>
      </PopupHeader>
      <PopupContent>
        <BookingTemplatesList onClickItem={onClose} />
      </PopupContent>
      <PopupFooter alignItems="stretch">
        <ButtonLink
          to="/booking-templates"
          onClick={onClose}
          data-userlane-id="button-new-quote-more-view-templates"
          fullWidth
        >
          {translate('booking-template_view_all')}
        </ButtonLink>
      </PopupFooter>
    </Popup>
  )
}
